class RepairableObject{
    constructor(id, state) {
        this.id = id;
        this.state = state;
        this.isReparing = false;
        this.isBreakDown = false;
    }
}
export default RepairableObject;